(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["client-services-faq"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initAccordion(root) {
      root.querySelectorAll('[data-client-services-faq-item]').forEach(function (item) {
        if (item.dataset.csfAccordionBound === 'true') return;
        item.dataset.csfAccordionBound = 'true';

        var btn = item.querySelector('.client-services-faq__trigger');
        var panel = item.querySelector('.client-services-faq__panel');
        if (!btn || !panel) return;

        btn.addEventListener('click', function () {
          var open = !item.classList.contains('is-open');
          item.classList.toggle('is-open', open);
          btn.setAttribute('aria-expanded', open ? 'true' : 'false');
          panel.setAttribute('aria-hidden', open ? 'false' : 'true');
        });
      });
    }

    function mount(context) {
      var scope = context && context.querySelector ? context : document;
      var roots = scope.querySelectorAll('[data-client-services-faq]');
      roots.forEach(function (root) {
        initAccordion(root);
      });
    }

    function boot() {
      mount(document);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }

    document.addEventListener('shopify:section:load', function (ev) {
      var el = ev.target;
      if (el && el.querySelector && el.querySelector('[data-client-services-faq]')) {
        el.querySelectorAll('[data-client-services-faq-item]').forEach(function (node) {
          delete node.dataset.csfAccordionBound;
        });
        mount(el);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mobile-home-actifs"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-actifs-section]').forEach(function (section) {
      var modal = section.querySelector('[data-actifs-modal]');
      if (!modal) return;

      var video = modal.querySelector('video');
      var triggers = section.querySelectorAll('[data-actifs-trigger]');
      var closeButtons = modal.querySelectorAll('[data-actifs-close]');
      if (!video || !triggers.length) return;

      function openModal(src) {
        if (src) {
          if (video.getAttribute('src') !== src) {
            video.setAttribute('src', src);
            video.load();
          }
        }
        modal.setAttribute('aria-hidden', 'false');
        document.body.style.overflow = 'hidden';
        video.currentTime = 0;
        video.play().catch(function () {});
      }

      function closeModal() {
        modal.setAttribute('aria-hidden', 'true');
        document.body.style.overflow = '';
        video.pause();
      }

      triggers.forEach(function (trigger) {
        trigger.addEventListener('click', function (e) {
          e.preventDefault();
          var src = trigger.getAttribute('data-actifs-mp4') || '';
          openModal(src);
        });
      });

      closeButtons.forEach(function (btn) {
        btn.addEventListener('click', closeModal);
      });

      modal.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') closeModal();
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mobile-home-card-carousel"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initMobileCardCarousel(root) {
      if (!root || root.dataset.cardCarouselInited === 'true') return;
      root.dataset.cardCarouselInited = 'true';

      const track = root.querySelector('[data-mobile-card-carousel]');
      const currentEl = root.querySelector('[data-card-carousel-current]');
      if (!track || !currentEl) return;

      const slides = track.querySelectorAll('.mobile-home-card-carousel__slide');
      const total = slides.length;
      if (total <= 1) return;

      function updatePagination() {
        const scrollLeft = track.scrollLeft;
        const cardWidth = track.firstElementChild ? track.firstElementChild.offsetWidth : track.offsetWidth;
        const gap = 3;
        const step = cardWidth + gap;
        const index = Math.round(scrollLeft / step) + 1;
        currentEl.textContent = String(Math.min(Math.max(1, index), total));
      }

      track.addEventListener('scroll', updatePagination, { passive: true });
      window.addEventListener('resize', updatePagination);
      updatePagination();
    }

    function initAllMobileCardCarousels() {
      document.querySelectorAll('.mobile-home-card-carousel').forEach(initMobileCardCarousel);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAllMobileCardCarousels);
    } else {
      initAllMobileCardCarousels();
    }

    document.addEventListener('shopify:section:load', function (event) {
      const root = event.target?.querySelector?.('.mobile-home-card-carousel');
      if (root) {
        delete root.dataset.cardCarouselInited;
        initMobileCardCarousel(root);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mobile-home-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const track = document.querySelector('[data-hero-track]');
    const currentEl = document.querySelector('[data-hero-current]');
    const totalEl = document.querySelector('[data-hero-total]');
    if (!track || !currentEl) return;

    const slides = track.querySelectorAll('.mobile-home-hero--slide');
    const total = slides.length;
    if (total <= 1) return;

    const pagination = currentEl.closest('.mobile-home-hero-carousel__pagination');
    const desktopMq = window.matchMedia('(min-width: 1200px)');

    function slidesPerView() {
      return desktopMq.matches ? 2 : 1;
    }

    function pageStep() {
      const slide = slides[0];
      if (!slide) return track.offsetWidth;
      const gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap) || 0;
      const perView = slidesPerView();
      return slide.offsetWidth * perView + gap * Math.max(0, perView - 1);
    }

    function updatePagination() {
      const perView = slidesPerView();
      const totalPages = Math.max(1, Math.ceil(total / perView));
      const step = pageStep();
      const page = step > 0 ? Math.round(track.scrollLeft / step) + 1 : 1;
      currentEl.textContent = String(Math.min(Math.max(1, page), totalPages));
      if (totalEl) totalEl.textContent = String(totalPages);
      if (pagination) pagination.hidden = totalPages <= 1;
    }

    track.addEventListener('scroll', updatePagination, { passive: true });
    window.addEventListener('resize', updatePagination);
    if (typeof desktopMq.addEventListener === 'function') {
      desktopMq.addEventListener('change', updatePagination);
    } else if (typeof desktopMq.addListener === 'function') {
      desktopMq.addListener(updatePagination);
    }
    updatePagination();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mobile-home-media-block"]) return;
  try {
    
  (function () {
    const trigger = document.querySelector('[data-media-block-trigger]');
    const modal = document.querySelector('[data-media-block-modal]');
    const closeButtons = document.querySelectorAll('[data-media-block-close]');
    if (!trigger || !modal) return;

    const video = modal.querySelector('video');
    if (!video) return;

    function openModal() {
      modal.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      video.currentTime = 0;
      video.play().catch(function () {});
    }

    function closeModal() {
      modal.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      video.pause();
    }

    trigger.addEventListener('click', function (e) {
      e.preventDefault();
      openModal();
    });

    closeButtons.forEach(function (btn) {
      btn.addEventListener('click', closeModal);
    });

    modal.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeModal();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mobile-home-nav"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const root = document.querySelector('[data-mobile-nav-root]');
    const toggle = document.querySelector('[data-mobile-menu-toggle]');
    const dropdown = document.querySelector('[data-mobile-menu-dropdown]');
    const closeTargets = document.querySelectorAll('[data-mobile-menu-close]');

    if (!root || !toggle || !dropdown) return;

    var drawerGapPx = 2;
    var savedScrollY = 0;
    var bodyScrollLocked = false;
    var compactScrollThreshold = 116;
    var compactFrame = 0;

    function syncCompactState() {
      var currentY = bodyScrollLocked ? savedScrollY : (window.scrollY || document.documentElement.scrollTop || 0);
      var shouldCompact = currentY > compactScrollThreshold;
      if (root.classList.contains('mobile-home-nav__root--compact') === shouldCompact) return;
      root.classList.toggle('mobile-home-nav__root--compact', shouldCompact);
      window.requestAnimationFrame(function () {
        syncDrawerTop();
        syncHeaderHeightVars();
      });
    }

    function requestCompactState() {
      if (compactFrame) return;
      compactFrame = window.requestAnimationFrame(function () {
        compactFrame = 0;
        syncCompactState();
      });
    }

    function lockBodyScroll() {
      if (bodyScrollLocked) return;
      savedScrollY = window.scrollY || document.documentElement.scrollTop || 0;
      document.body.style.position = 'fixed';
      document.body.style.top = '-' + savedScrollY + 'px';
      document.body.style.left = '0';
      document.body.style.right = '0';
      document.body.style.width = '100%';
      bodyScrollLocked = true;
    }

    function unlockBodyScroll() {
      if (!bodyScrollLocked) return;
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.left = '';
      document.body.style.right = '';
      document.body.style.width = '';
      bodyScrollLocked = false;
      window.scrollTo(0, savedScrollY);
    }

    function syncDrawerTop() {
      var pill = document.querySelector('.mobile-home-nav__pill');
      if (!pill) return;
      var rect = pill.getBoundingClientRect();
      var pillBottom = Math.ceil(rect.bottom);
      document.documentElement.style.setProperty('--mobile-menu-backdrop-top', pillBottom + 'px');
      document.documentElement.style.setProperty(
        '--mobile-menu-drawer-top',
        pillBottom + drawerGapPx + 'px'
      );
    }

    function syncHeaderHeightVars() {
      var pill = document.querySelector('.mobile-home-nav__pill');
      var section = pill ? pill.closest('.shopify-section') : null;
      if (!pill || !section) return;
      var marginY = 12;
      var h = Math.ceil(pill.getBoundingClientRect().height + marginY);
      var groupH = Math.ceil(section.offsetHeight);
      document.body.style.setProperty('--header-height', h + 'px');
      document.body.style.setProperty('--header-group-height', groupH + 'px');
    }

    function closeLocalizationDisclosures() {
      var countryDisclosure = dropdown.querySelector('[data-mobile-country-disclosure]');
      var languageDisclosure = dropdown.querySelector('[data-mobile-language-disclosure]');
      if (countryDisclosure && countryDisclosure.open) countryDisclosure.open = false;
      if (languageDisclosure && languageDisclosure.open) languageDisclosure.open = false;
    }

    function openMenu() {
      lockBodyScroll();
      syncDrawerTop();
      closeLocalizationDisclosures();
      resetLuxAccordion();
      dropdown.removeAttribute('hidden');
      dropdown.setAttribute('aria-hidden', 'false');
      toggle.setAttribute('aria-expanded', 'true');
      root.classList.add('mobile-home-nav__root--open');
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          syncDrawerTop();
          syncHeaderHeightVars();
        });
      });
    }

    function resetLuxAccordion() {
      var items = dropdown.querySelectorAll('[data-lux-accordion-item]');
      items.forEach(function (item) {
        item.classList.remove('mobile-home-nav__lux-item--open');
        var panel = item.querySelector('.mobile-home-nav__lux-panel');
        var trig = item.querySelector('[data-lux-accordion-trigger]');
        if (panel) panel.setAttribute('aria-hidden', 'true');
        if (trig) {
          trig.setAttribute('aria-expanded', 'false');
          var expandLab = trig.getAttribute('data-expand-label');
          if (expandLab) trig.setAttribute('aria-label', expandLab);
        }
        item.querySelectorAll('.mobile-home-nav__lux-sublink').forEach(function (a) {
          a.setAttribute('tabindex', '-1');
        });
      });
    }

    function closeMenu() {
      unlockBodyScroll();
      closeLocalizationDisclosures();
      resetLuxAccordion();
      dropdown.setAttribute('hidden', '');
      dropdown.setAttribute('aria-hidden', 'true');
      toggle.setAttribute('aria-expanded', 'false');
      root.classList.remove('mobile-home-nav__root--open');
      requestAnimationFrame(function () {
        requestAnimationFrame(syncHeaderHeightVars);
      });
    }

    function isOpen() {
      return toggle.getAttribute('aria-expanded') === 'true';
    }

    toggle.addEventListener('click', function () {
      if (isOpen()) closeMenu();
      else openMenu();
    });

    window.addEventListener('resize', function () {
      syncDrawerTop();
      if (isOpen()) syncHeaderHeightVars();
    });

    window.addEventListener('orientationchange', function () {
      requestAnimationFrame(function () {
        syncCompactState();
        syncDrawerTop();
        if (isOpen()) syncHeaderHeightVars();
      });
    });

    window.addEventListener('scroll', requestCompactState, { passive: true });

    syncCompactState();
    syncDrawerTop();

    closeTargets.forEach(function (el) {
      el.addEventListener('click', closeMenu);
    });

    dropdown.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeMenu();
    });

    const searchBtn = dropdown.querySelector('search-button button');
    if (searchBtn) {
      searchBtn.addEventListener('click', function () {
        if (isOpen()) closeMenu();
      }, true);
    }

    const countryDisclosure = dropdown.querySelector('[data-mobile-country-disclosure]');
    const languageDisclosure = dropdown.querySelector('[data-mobile-language-disclosure]');
    if (countryDisclosure) {
      countryDisclosure.addEventListener('toggle', function () {
        if (countryDisclosure.open) {
          if (languageDisclosure) languageDisclosure.open = false;
          resetLuxAccordion();
        }
      });
    }

    if (languageDisclosure) {
      languageDisclosure.addEventListener('toggle', function () {
        if (languageDisclosure.open) {
          if (countryDisclosure) countryDisclosure.open = false;
          resetLuxAccordion();
        }
      });
    }

    document.addEventListener('click', function (event) {
      if (countryDisclosure && countryDisclosure.open && !countryDisclosure.contains(event.target)) {
        countryDisclosure.open = false;
      }
      if (languageDisclosure && languageDisclosure.open && !languageDisclosure.contains(event.target)) {
        languageDisclosure.open = false;
      }
    });

    (function initLuxAccordion() {
      var nav = dropdown.querySelector('[data-lux-accordion-nav]');
      if (!nav) return;

      var items = nav.querySelectorAll('[data-lux-accordion-item]');
      var fineHover = window.matchMedia('(hover: hover) and (pointer: fine)');

      function openOnly(activeItem) {
        items.forEach(function (item) {
          var panel = item.querySelector('.mobile-home-nav__lux-panel');
          var trig = item.querySelector('[data-lux-accordion-trigger]');
          var isActive = item === activeItem;

          if (isActive) {
            item.classList.add('mobile-home-nav__lux-item--open');
            if (panel) panel.setAttribute('aria-hidden', 'false');
            if (trig) {
              trig.setAttribute('aria-expanded', 'true');
              var collapseLab = trig.getAttribute('data-collapse-label');
              if (collapseLab) trig.setAttribute('aria-label', collapseLab);
            }
            item.querySelectorAll('.mobile-home-nav__lux-sublink').forEach(function (a) {
              a.removeAttribute('tabindex');
            });
          } else {
            item.classList.remove('mobile-home-nav__lux-item--open');
            if (panel) panel.setAttribute('aria-hidden', 'true');
            if (trig) {
              trig.setAttribute('aria-expanded', 'false');
              var expandLab = trig.getAttribute('data-expand-label');
              if (expandLab) trig.setAttribute('aria-label', expandLab);
            }
            item.querySelectorAll('.mobile-home-nav__lux-sublink').forEach(function (a) {
              a.setAttribute('tabindex', '-1');
            });
          }
        });
      }

      function closeAll() {
        items.forEach(function (item) {
          item.classList.remove('mobile-home-nav__lux-item--open');
          var panel = item.querySelector('.mobile-home-nav__lux-panel');
          var trig = item.querySelector('[data-lux-accordion-trigger]');
          if (panel) panel.setAttribute('aria-hidden', 'true');
          if (trig) {
            trig.setAttribute('aria-expanded', 'false');
            var expandLab = trig.getAttribute('data-expand-label');
            if (expandLab) trig.setAttribute('aria-label', expandLab);
          }
          item.querySelectorAll('.mobile-home-nav__lux-sublink').forEach(function (a) {
            a.setAttribute('tabindex', '-1');
          });
        });
      }

      items.forEach(function (item) {
        var trig = item.querySelector('[data-lux-accordion-trigger]');
        if (!trig) return;

        trig.addEventListener('click', function (ev) {
          ev.preventDefault();
          closeLocalizationDisclosures();
          var wasOpen = item.classList.contains('mobile-home-nav__lux-item--open');
          if (wasOpen) {
            closeAll();
            return;
          }
          openOnly(item);
        });

        if (fineHover.matches) {
          item.addEventListener('mouseenter', function () {
            openOnly(item);
          });
        }
      });

      if (fineHover.matches) {
        nav.addEventListener('mouseleave', function (ev) {
          if (!nav.contains(ev.relatedTarget)) closeAll();
        });
      }
    })();

    const annRoot = document.querySelector('[data-announcement-root]');
    const track = document.querySelector('[data-announcement-track]');
    const prevBtn = document.querySelector('[data-announcement-prev]');
    const nextBtn = document.querySelector('[data-announcement-next]');
    if (annRoot && track && prevBtn && nextBtn) {
      const slides = track.querySelectorAll('[data-announcement-slide]');
      const total = slides.length;
      if (total > 1) {
        let index = 0;
        function go(i) {
          index = ((i % total) + total) % total;
          track.style.transform = 'translateX(-' + index * 100 + '%)';
        }
        prevBtn.addEventListener('click', function () {
          go(index - 1);
        });
        nextBtn.addEventListener('click', function () {
          go(index + 1);
        });
      }
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
